import type { LoaderFunctionArgs } from 'react-router';
import ROUTES from '@/routes';
import { useMessageStore } from '@/stores/message';
import { parseSessionKey } from '@/utils/session';

export default function mediaMessageLoader({ params, request }: LoaderFunctionArgs) {
  const [, storeId] = parseSessionKey(useMessageStore.getState().key);

  const sessionType = request.url.includes('groups') ? 'group' : 'session';
  const { id } = (sessionType === 'group' ? ROUTES.MESSAGES.GROUPS : ROUTES.MESSAGES.SESSIONS).$deserializeParams(
    params,
  );

  return {
    promises:
      !useMessageStore.getState().hydrated || storeId !== id
        ? useMessageStore.getState().hydrate({
            type: sessionType,
            id,
          })
        : Promise.resolve(true),
  };
}
